import styled from "styled-components";
import { Colors } from "@smartsuite/types";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  padding: 10px 10px;
  margin-bottom: 18px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${Colors.dwRed};
    border-radius: 8px;
    z-index: -1;
    opacity: 0.5;
  }
`;

export const Title = styled.span`
  margin-bottom: 10px;
  margin-right: 7px;
`;

export const Text = styled.span`
  display: flex;
  position: relative;
  top: -1px;
  margin-bottom: 5px;
`;

export const Content = styled.div`
  display: flex;
`;

export const ErrorBox = styled.div`
  display: flex;
  flex-direction: column;
`;
